module.exports = __webpack_public_path__ + "b021f127e22ebc9e8ba9e30faa24c4ab.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-768.webp
// module id = 382
// module chunks = 0